import { NOTIFY_APPOINTMENT, NOTIFY_SYSTEM , MARK_AS_READ} from './notifyTypes'
import { URL_NOTIFY_APPOINTMENT, URL_NOTIFY_SYSTEM , URL_MARK_AS_READ} from './notifyUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
import axios from "../../axios";

export default {
  [NOTIFY_APPOINTMENT]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_NOTIFY_APPOINTMENT}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(NOTIFY_APPOINTMENT, data)
              resolve(data);
            } else {
              commit(NOTIFY_APPOINTMENT, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(NOTIFY_APPOINTMENT, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  [NOTIFY_SYSTEM]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_NOTIFY_SYSTEM}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(NOTIFY_SYSTEM, data)
              resolve(data);
            } else {
              commit(NOTIFY_SYSTEM, { items: [], _links: {}, _meta: {} });
              resolve({ items: [], _links: {}, _meta: {} });
            }
          } else {
            commit(NOTIFY_SYSTEM, { items: [], _links: {}, _meta: {} });
            resolve({ items: [], _links: {}, _meta: {} });
          }
        })
        .catch((error) => { reject(error); })
    })
  },

  // eslint-disable-next-line
  [MARK_AS_READ] ({} , item) {
    var bodyFormData = new FormData();
    for(var key in item){
      bodyFormData.append(key, item[key])
    }
    return new Promise((resolve, reject) => {
      axios.post(`${URL_MARK_AS_READ}`, bodyFormData)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  // [NOTIFY_SYSTEM]({ commit }, item) {
  //   let param = new URLSearchParams(item).toString();
  //   return new Promise((resolve, reject) => {
  //     axios.get(URL_NOTIFY_SYSTEM, { params: param })
  //       .then((response) => {
  //         let responseModel = new ResponseModel(response);
  //         if (responseModel.status == STATUS_OK) {
  //           let resultModel = responseModel.result;
  //           if (resultModel.status == STATUS_OK) {
  //             let data = resultModel.data;
  //             commit(NOTIFY_SYSTEM, data)
  //             resolve(data);
  //           } else {
  //             commit(NOTIFY_SYSTEM, { items: [], _links: {}, _meta: {} });
  //             resolve({ items: [], _links: {}, _meta: {} });
  //           }
  //         } else {
  //           commit(NOTIFY_SYSTEM, { items: [], _links: {}, _meta: {} });
  //           resolve({ items: [], _links: {}, _meta: {} });
  //         }
  //       })
  //       .catch((error) => { reject(error); })
  //   })
  // },
}
